<template>
  <accordion-section
    :open="section === 8"
    :valid="!!description"
    @selected="$emit('openSection', 8)"
  >
    <template #heading>
      Description
    </template>

    <textarea
      v-model="description"
      class="description"
      placeholder="Add a description about your business"
      :disabled="!canEditLocation"
    />

    <small
      v-for="(error, index) in validationErrors['profile.description']"
      :key="index"
      class="validation"
    >{{ error }}</small>

    <div class="recommendations">
      <span>Recommendations</span>
      <p class="sub">
        You can write a description of up to 750 characters, however, only the first 244 characters
        display on your Google listing unless the visitor clicks “More”.
      </p>
      <p class="sub">
        Recommendations for business descriptions:
      </p>
      <ul>
        <li>
          Think about what you’d want your customers to know most about your business.
          Pretend they know nothing about you.
        </li>
        <li>
          Use the most important terms that potential customers might be looking for, but do not keyword stuff.
          It is not believed that Google uses the description field as a factor in search rankings.
          However, a well-written description could help convert someone looking at your listing into a customer.
        </li>
        <li>Don’t use all-caps, emojis, or other “gimmicky character use”.</li>
        <li>Do not focus on promotions, prices, or sales. Tell people about your business instead.</li>
        <li>Do not use any URLs.</li>
      </ul>
    </div>
  </accordion-section>
</template>

<script>
import AccordionSection from "../items/AccordionSection";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  components: {
    AccordionSection
  },
  props: {
    section: {
      type: Number,
      required: true,
    },
  },
  emits: ['openSection'],
  computed: {
    description: {
      get() {
        return this.$store.getters['businessProfile/description'];
      },
      set(value) {
        this.updateDescription(value);
      }
    },
    ...mapGetters('user', [
        'canEditLocation',
    ]),
    ...mapGetters('businessProfile', [
      'validationErrors',
    ]),
  },
  methods: {
    ...mapMutations('editListing', [
      'setSelectedSection',
    ]),
    ...mapActions('businessProfile', [
      'updateDescription',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.description {
  height: 10rem;
  width: 100%;
  color: #4E4E54;
  background-color: #fff;
  border: 1px solid #E8E5E2;
  padding: 14.5px 24.5px 15.5px;
  border-radius: 12px;
  font-size: 14px;
  letter-spacing: -0.5px;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;

  &[disabled] {
    background-color: #e9ecef;
    opacity: .5;
  }

  &::-webkit-input-placeholder {
    color: #9999a3;
    -webkit-transition: .3s;
    transition: .3s;
  }

  &::-moz-placeholder {
    color: #9999a3;
    -moz-transition: .3s;
    transition: .3s;
  }

  &:-ms-input-placeholder {
    color: #9999a3;
    -ms-transition: .3s;
    transition: .3s;
  }

  &::-ms-input-placeholder {
    color: #9999a3;
    -ms-transition: .3s;
    transition: .3s;
  }

  &::placeholder {
    color: #9999a3;
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;
  }

  &:focus::-webkit-input-placeholder {
    color: transparent;
  }

  &:focus::-moz-placeholder {
    color: transparent;
  }

  &:focus:-ms-input-placeholder {
    color: transparent;
  }

  &:focus::-ms-input-placeholder {
    color: transparent;
  }

  &:focus::placeholder {
    color: transparent;
  }
}
.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}
</style>
